<template>
  <div class="comments__wrapper">
    <CustomDataTable
      :items="items"
      :headers="headers"
      entity-type="comments"
      :disable-pagination="true"
    >
      <template v-slot:tools="{ item }">
        <v-icon
          small
          @click="deleteRow(item)"
        >mdi-delete</v-icon>
      </template>
    </CustomDataTable>
    <ConfirmDialog
      v-if="confirmDialogLoaded"
      :dialog="confirmDialogVisible"
      @success="confirmDelete()"
      @cancel="confirmDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`offer.comments.deleteHeader`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`offer.comments.deleteBody`) }}</p>
      </template>
    </ConfirmDialog>
    <AddComment
      @addedItem="addedItem" 
      :entity-id="entityId" 
    />
  </div>
</template>

<script>
import CustomDataTable from '@/components/CustomDataTable';

export default {
  name: 'CommentsTable',
  props: {
    entityType: {
      required: true,
      type: String
    },
    entityId: {
      required: true,
      type: [String, Number]
    },
    entities: {
      required: false,
      type: Array
    }
  },
  components: {
    CustomDataTable,
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    AddComment: () => import('@/components/AddComment')
  },
  data: () => ({
    confirmDialogLoaded: true,
    confirmDialogVisible: false,
    selectedItemIndex: undefined,
    items: [],
    headers: [
      {
        text: 'content',
        value: 'content',
        type: 'text'
      },
      {
        text: 'created_at',
        value: 'created_at',
        type: 'date'
      },
      {
        text: 'user',
        type: 'text',
        value: 'user'
      }
    ]
  }),
  methods: {
    addedItem(item) {
      this.items.unshift(item);
    },
    deleteRow(item) {
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
      this.deleteItemId = item.id;
      this.deleteItemIndex = this.items.indexOf(item);
    },
    getComments() {
      this.$store
        .dispatch('getComments', {
          type: this.entityType,
          id: this.entityId
        })
        .then(r => {
          if (r.status === 200) {
            const { comments } = r.data;
            if (Array.isArray(comments)) {
              this.items = comments;
            } else {
              this.comments = comments;
              this.prepareComments(comments);
            }
          }
        });
    },
    confirmDelete() {
      this.$store.dispatch('deleteComment', this.deleteItemId).then(() => {
        this.items.splice(this.deleteItemIndex, 1);
      });
      this.confirmDialogVisible = false;
    },
    prepareComments(commentsObject) {
      this.headers.push({
        text: this.entityType === 'offer' ? 'nr_ew_dzialek' : 'nr_oferty',
        value: 'fromEntity',
        type: 'text',
        translate: this.entityType === 'project',
        nullValueKey: 'default.notApplicable'
      });
      this.items = Object.keys(commentsObject).reduce((total, key) => {
        return [...total, ...commentsObject[key]];
      }, []);
      const subEntityName = this.entityType === 'offer' ? 'parcel' : 'offer';
      this.items.forEach(item => {
        if (item.entity_type === subEntityName) {
          const entity = this.entities.find(
            entity => entity.id === item.entity_id
          );
          item.fromEntity =
            this.entityType === 'project'
              ? entity.nazwa_nieruchomosci
              : entity.nr_ew_dzialek;
        } else {
          item.fromEntity = null;
        }
      });
    }
  },
  mounted() {
    this.getComments();
  },
  watch: {
    entityId() {
      this.getComments();
    }
  }
};
</script>

<style lang="scss">
.comments__wrapper {
  height: 100%;
}
</style>
